export class DueDateStatsModel {
    public id: string;
    public userId: string;
    public dueDate: Date; // The date the user answered the question, should answer it next OR the date they were _supposed_ to answer.
    public percentComplete: number;
    public countDue?: number;
    public countReviewed?: number;
    public cardsToday: string[];
    public cardsDue: [{
        deckId: string;
        cardId: string; 
        reviewed: boolean;
    }];
}
